/** iOS-style ON/OFF switch used in Settings, Sandbox, and multiplayer toggles. */

export function syncToggleSwitch(btn: HTMLElement | null | undefined, on: boolean): void {
    if (!btn) return;
    btn.classList.add("toggleSwitch");
    btn.classList.remove("btn", "green", "toggleOff");
    btn.classList.toggle("toggleOn", on);
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    if (btn.textContent === "ON" || btn.textContent === "OFF") btn.textContent = "";
}
